import {createSlice} from "@reduxjs/toolkit";
import {extraReducers} from "./action";


const initialState = {
    menu: [],
    loadingStatus: 'loaded',
    currentLayoutType: null
}

const navMenuSlice = createSlice({
        name: 'navMenu',
        initialState,
        reducers: {
            setCurrentLayoutType(state, action) {
                state.currentLayoutType = action.payload;
            },
        },
        extraReducers: extraReducers
    }
);

const {actions, reducer} = navMenuSlice;

export default reducer;

export const {setCurrentLayoutType} = actions;
